import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { ECommerceApplicationsData, } from "../../common";
// core components
import { Card, CardBody, CardSubtitle, CardTitle, Col, Container, Row } from "reactstrap";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import { getIPGeoLocation } from "../../common/GeneralUtils";
// import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import * as Icons from '../../common/icons/eCommerceApplicationsIcons';
import Toasts from "../../components/Toasts/Toasts";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )

const ECommerceApplicationsScreen = () => {
    const [toasts, setToasts] = useState(null)
    const [WebAppDevelopmentData, setData] = useState({});
    const [ECommerceApplicationsData, setECommerceApplicationsData] = useState({});

    const getAllWebAppDevelopmentData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/webAppDevelopmentData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    const getAllECommerceApplicationsData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/eCommerceApplicationsData.json');
            setECommerceApplicationsData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getIPGeoLocation();
        getAllWebAppDevelopmentData();
        getAllECommerceApplicationsData();
    }, [])
    return (
        <Fragment>
            <Helmet>
                <title>E-commerce App Development Services for Online Growth</title>
                <meta name="description" content="Launch your online store effortlessly with VarahiSoft’s robust e-commerce application services designed to boost sales, user experience, and business growth." />
                <meta name="keywords" content="e commerce applications service" />
                <meta property="og:title" content="E-commerce App Development Services for Online Growth" />
            </Helmet>
            <div id="main-wrapper">
                <Header />
                <div className="page-wrapper e-commerce-page-wrapper">
                    <div className="container-fluid">
                        <div className="page-content-top">
                            <AboutUsBanner bannerImg={ECommerceApplicationsData?.bannerImg} data={ECommerceApplicationsData?.headerData} />
                            <div className="content-tech-page-warper">
                                <Container>
                                    <div className="page-context-text">
                                        <h2>{ECommerceApplicationsData?.BuildFuture?.title}</h2>
                                        {ECommerceApplicationsData?.BuildFuture?.textData.map((text, index) => <p key={index}><span>{text?.text}</span> <span className="fw-bold">{text?.bold1}</span> <span>{text?.text1}</span> <span className="fw-bold">{text?.bold2}</span> <span>{text?.text2}</span></p>)}
                                    </div>
                                </Container>
                            </div>
                            <section className="why-mobile-app-development">
                                <Container>
                                    <Row>
                                        <Col lg={6} md={6} className="m-auto text-start">
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    src={ECommerceApplicationsData?.WhyMobileAppDevelopment?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                            {/* <img src={tech?.pageImg} alt="img" /> */}
                                        </Col>
                                        <Col className="tech-page-warper px-5" lg={6} md={6}>
                                            <h3 className="pe-3">{ECommerceApplicationsData?.WhyMobileAppDevelopment?.title}</h3>
                                            {ECommerceApplicationsData?.WhyMobileAppDevelopment?.paragraph?.map((para, index) => {
                                                return (
                                                    <p key={index}>{para?.text}</p>
                                                )
                                            })}
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="comprehensive-E-Commerce-solutions">
                                <Container>
                                    <div className="comprehensive-header mb-5">
                                        <h3>{ECommerceApplicationsData?.ComprehensiveECommerceSolutions?.title}</h3>
                                        <p>{ECommerceApplicationsData?.ComprehensiveECommerceSolutions?.subTitle}</p>
                                    </div>
                                    <div className="comprehensive-body-card">
                                        {ECommerceApplicationsData?.ComprehensiveECommerceSolutions?.listData.map((list, index) => {
                                            const Icon = Icons[list?.icon] || null;
                                            return (
                                                <Card key={index} className="app-card">
                                                    <CardBody className="d-flex align-items-center justify-content-start gap-3">
                                                        <div>
                                                            {Icon && <Icon />}
                                                        </div>
                                                        <div>
                                                            <CardTitle className="m-auto">{list?.title}</CardTitle>
                                                            <CardSubtitle className="m-0">{list?.text} <b>{list?.bold}</b> {list?.text1}</CardSubtitle>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            )
                                        })}
                                    </div>
                                </Container>
                            </section>
                            <section className="core-mobile-app-process" >
                                <Container>
                                    <h3>{ECommerceApplicationsData?.WhyChooseVarahiSoftforECommerceDevelopment?.title}</h3>
                                    <h4>{ECommerceApplicationsData?.WhyChooseVarahiSoftforECommerceDevelopment?.subTitle}</h4>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        src={ECommerceApplicationsData?.WhyChooseVarahiSoftforECommerceDevelopment?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                            <Col className="content-body" lg={6} md={6} xs={12}>
                                                {ECommerceApplicationsData?.WhyChooseVarahiSoftforECommerceDevelopment?.listData?.map((chooseData, index) => {
                                                    const ChooseDataIcon = Icons[chooseData?.icon] || null;
                                                    return (
                                                        <div key={index} className="px-5 d-flex align-items-start justify-content-start gap-3">
                                                            <div className="why-choose-icon">{ChooseDataIcon && <ChooseDataIcon />}</div>
                                                            <div className="why-cho0se-body">
                                                                <h5>
                                                                    {chooseData?.title}
                                                                </h5>
                                                                <p>{chooseData?.text}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className="PlatformsAndTechnologies">
                                <Container>
                                    <h3>{ECommerceApplicationsData?.PlatformsAndTechnologies?.title}</h3>
                                    <h4>{ECommerceApplicationsData?.PlatformsAndTechnologies?.subTitle}</h4>
                                    <div className="technologies d-flex align-items-center justify-content-center gap-4 my-5">
                                        {ECommerceApplicationsData?.PlatformsAndTechnologies?.technologies?.map((tech, index) => {
                                            return (
                                                <div key={index} className="tech-div-button">{tech?.name}</div>
                                            )
                                        })}
                                    </div>
                                    <div className="paragraph-div">
                                        {ECommerceApplicationsData?.PlatformsAndTechnologies?.paragraph?.map((para, index) => {
                                            return (
                                                <p key={index} className="tech-div-button">{para?.text}</p>
                                            )
                                        })}
                                    </div>
                                </Container>
                            </section>
                            <section className='Tech-Industry-Quality'>
                                <div className='tech-content py-5' style={{ backgroundImage: `url(${ECommerceApplicationsData?.TurningIdeas?.bgImg})` }}>
                                    <div className="bg-color-rgba">
                                        <Container className="py-4 ps-5">
                                            <Row className="justify-content-end">
                                                <Col lg="7" md="7" className="align-self-start">
                                                    <div className='page-content pb-5'>
                                                        <h3>{ECommerceApplicationsData?.TurningIdeas?.title}</h3>
                                                        {ECommerceApplicationsData?.TurningIdeas?.paragraph?.map((para, index) => {
                                                            return (
                                                                <p key={index}>{para?.text}<Link className='text-decoration-none text-white' to={window?.location?.origin}>{para?.link}</Link> {para?.text1}</p>
                                                            )
                                                        })}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </section>
                            <CustomerReviews />
                            <div className="home-contact-page">
                                <ContactUsComponent setToasts={setToasts} />
                            </div>
                            <FrequentlyAskedQuestions faqData={WebAppDevelopmentData?.FrequentlyAskedQuestionsData} />
                        </div>
                    </div>
                </div>
                <Footer />
                {toasts && <Toasts toastsList={toasts} />}
            </div>
        </Fragment>
    );
}

ECommerceApplicationsScreen.propTypes = {
    classes: PropTypes.object
};

export default ECommerceApplicationsScreen;
